import { render, staticRenderFns } from "./Taskbar.vue?vue&type=template&id=ba9c6800&scoped=true&"
import script from "./Taskbar.vue?vue&type=script&lang=js&"
export * from "./Taskbar.vue?vue&type=script&lang=js&"
import style0 from "./Taskbar.vue?vue&type=style&index=0&id=ba9c6800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9c6800",
  null
  
)

export default component.exports